import _ from 'lodash';
import { createSelector } from 'reselect';
import { selectors as contentSelectors } from 'edrolo/reducers/content';

const createLessonContentSelectors = _.memoize((lessonId) => {
  const getLesson = createSelector(
    [contentSelectors.getAllLessons],
    (allLessons) => allLessons && allLessons.get(lessonId)
  );

  const getLessonChunks = createSelector(
    [contentSelectors.getAllLessons, contentSelectors.getAllChunks],
    (allLessons, allChunks) => {
      const chunkIds =
        allLessons && allLessons.getIn([`${lessonId}`, 'chunks']);
      return (
        chunkIds &&
        chunkIds.map((chunkId) => allChunks && allChunks.get(`${chunkId}`))
      );
    }
  );

  const getTotalLessonDuration = createSelector(
    [getLessonChunks],
    (lessonChunks) =>
      lessonChunks &&
      lessonChunks.reduce((acc, chunk) => acc + chunk.get('duration'), 0)
  );

  const getTotalLessonQuizMarks = createSelector(
    [getLessonChunks],
    (lessonChunks) =>
      (lessonChunks || [])
        .map((chunk) => {
          // TBC: sooo what needs to be done here?
          // this is due to having different serializers for lesson grid and studyplanner content apis..
          // must align these.
          const marks =
            chunk.getIn(['question', 'marks_available']) ||
            chunk.getIn(['marks_available']);
          return marks;
        })
        .filter((marks_available) => marks_available)
        .reduce((prev, current) => prev + current, 0)
  );

  const getLessonResources = createSelector(
    [contentSelectors.getAllLessonResources],
    (allLessonResources) =>
      allLessonResources
        .filter((att) => att.get('object_id') === lessonId)
        .sort((a, b) => a.get('title').localeCompare(b.get('title')))
        .toList()
  );

  return {
    getLesson,
    getLessonChunks,
    getTotalLessonDuration,
    getTotalLessonQuizMarks,
    getLessonResources,
  };
});

export default createLessonContentSelectors;
